import Vue from 'vue';
import Vuex from 'vuex';

import state from './state';
import mutations from './mutations';
import * as actions from './actions';
import * as getters from './getters';

import modules from './modules';
import plugins from './plugins';

Vue.use(Vuex);

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',

  state,
  mutations,
  actions,

  modules,
  plugins,

  getters,
});



// WEBPACK FOOTER //
// ./src/store/index.js